import { Box, Button, Grid, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { ArrowLeftCircle, ArrowRightCircle, FileText, Info, Plus, Trash2 } from 'react-feather';

import {
    TooltipInformation,
    TooltipApprovalInfo,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const LegalizationPaymentStep = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData 
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { formOpeningMode } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    const { fetchManagementLegalizationPayment } = FetchData
    const { dataLegalizationPayment, loadingFetchTransactions } = fetchManagementLegalizationPayment

    // ------------------------------------------------ Actions
    const { 
        handleClickShowLegalizationTransactionInfo,
        handleClickDeleteTransaction,
        handleClickPrintLegalizationTicket,
        handleClickReturnStep,
        handleClickLoadLegalizationFiles
    } = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { field: "movimiento_fecha", headerName: "FECHA", minWidth: 110, maxWidth: 110, filter: true },
        { 
            field: "movimiento_tipo", headerName: "TIPO", minWidth: 100, maxWidth: 100, filter: true,
            cellClass: (params) => {
                return params.value === 'EFECTIVO' ? 'bg-primary' : 'bg-secondary text-white';
            },
        },
        // { field: "movimiento_monto", headerName: "MONTO", minWidth: 100, maxWidth: 100, filter: true },
        { field: "movimiento_moneda", headerName: "MONEDA", minWidth: 120, maxWidth: 120, filter: true },
        // { field: "movimiento_tipo_cambio", headerName: "CAMBIO", minWidth: 120, maxWidth: 120, filter: true },
        { field: "movimiento_quetzales", headerName: "TOTAL (Q)", minWidth: 120, maxWidth: 120, filter: true },
        { field: "movimiento_dolares", headerName: "TOTAL ($)", minWidth: 120, maxWidth: 120, filter: true },
        // { field: "movimiento_observaciones", headerName: "movimiento_observaciones", filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 175,
            maxWidth: 175,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if(params.value === 'APROBADO') return 'bg-success';
                if(params.value === 'PENDIENTE') return 'bg-warning';
                if(params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                // const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                if(params.value === 'APROBADO') return (
                    <TooltipApprovalInfo
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                        texto_approval='APROBADO'
                    />
                );

                if(params.value === 'PENDIENTE') return (
                    <TooltipApprovalInfo
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                        texto_approval='PENDIENTE'
                    />
                );

                if(params.value === 'RECHAZADO') return (
                    <TooltipApprovalInfo
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                        texto_approval='RECHAZADO'
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                // const {idmovimiento, aprobacion_check} = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickShowLegalizationTransactionInfo(
                                '',
                                'REGISTRAR TRANSACCION',
                                'LegalizationPayment',
                                {...params.data},
                                'EDITABLE'
                            )}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Ver Info" />
                        </MenuItem>
                        {/* {( ['APROBADO', 'PENDIENTE'].includes(aprobacion_check) ) && (
                            <MenuItem
                                onClick={() => handleClickPrintLegalizationTicket(idmovimiento)}
                            >
                                <ListItemIcon> <FileText color="black"/> </ListItemIcon>
                                <ListItemText primary="Recibo" />
                            </MenuItem>
                        )}
                        {( ['PENDIENTE'].includes(aprobacion_check) ) && (
                            <MenuItem
                                onClick={() => handleClickDeleteTransaction(idmovimiento)}
                            >
                                <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                <ListItemText primary="Eliminar" />
                            </MenuItem>
                        )} */}
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        <>
            <p className='text-info'>* Monto a cancelar: Q{formState.legalizacion_pago}</p>

            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    {(loadingFetchTransactions) && (<LinearLoading />)}
                    <CustomTableData 
                        rowConfig={dataLegalizationPayment}
                        columnConfig={columnConfig}
                        // handleClicks
                        // Funciones
                    />
                </Grid>
            </Grid>

            <div className="pt-4"></div>
                <Box className="text-center" sx={{mt: 2}}>
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="outlined"
                        type="button" 
                        className='btn-round'
                        color='warning'
                        onClick={handleClickReturnStep} 
                        sx={{ marginRight: 1, marginLeft: 1 }}
                    >
                        Volver
                    </Button>
                    <Button
                        endIcon={<ArrowRightCircle/>}
                        variant="outlined"
                        className='btn-round'
                        color='warning'
                        onClick={ () => handleClickLoadLegalizationFiles(formState.idgestion) }
                        sx={{ marginRight: 1, marginLeft: 1 }}
                    >
                        Continuar
                    </Button>
                </Box>
        </>
    )
}
